import rightImg from "images/hero-right1.png";
import React, { FC } from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet-async";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionPromo3 from "components/SectionPromo3";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About</title>
      </Helmet>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <SectionHero
          rightImg={rightImg}
          heading="👋 About Us."
          btnText=""
          subHeading="Sanolink is here to transform your health and wellness journey. We connect you with expert coaches for a personalized path to well-being, encompassing physical and mental health. Join us in making a healthier world a reality!"
        />

        <SectionFounder />

        <SectionHero
          rightImg={rightImg}
          heading="🎯 Our Mission."
          btnText=""
          subHeading="We're on a quest to revolutionize the way the world approaches health and wellness.

          By making expert guidance and support easily accessible, we empower individuals to take charge of their physical and mental well-being.
          
          Join us in our mission to create a healthier, happier world for everyone. Together, we can make it happen."
        />

        {/* <SectionStatistic /> */}

        {/* <SectionPromo3 /> */}
      </div>
    </div>
  );
};

export default PageAbout;
